<template>
  <div class="modal__row">
    <div class="modal__body-name">
      Фамилия Имя Отчество
    </div>
    <div class="modal__body-value">
      {{ item.fullName }}
    </div>
  </div>
  <div class="modal__row">
    <div class="modal__body-name">
      Должность
    </div>
    <div class="modal__body-value">
      {{ item.position }}
    </div>
  </div>
  <div class="modal__row">
    <div class="modal__body-name">
      Адрес электронной почты
    </div>
    <div class="modal__body-value">
      {{ item.email }}
    </div>
  </div>
  <div class="modal__row">
    <div class="modal__body-name">
      Телефон
    </div>
    <div class="modal__body-value">
      {{ item.phone }}
    </div>
  </div>
  <div class="modal__row">
    <div class="modal__body-name">
      Тип участника
    </div>
    <div
      v-if="hasCustomerRole(item)"
      class="modal__body-value"
    >
      {{ roles }}
    </div>
    <div
      v-else
      class="modal__body-value"
    >
      <SelectForm
        v-model:value="roleIds"
        :options="allowRoles"
        form-key="roleIds"
        :form-model="_"
        :is-multiple="true"
      />
    </div>
  </div>
  <div class="modal__row mt-3">
    <div class="modal__body-name">
      Текущий статус
    </div>
    <div class="modal__body-value">
      <SimpleSelect
        light
        :default="status"
        :options="statusOptions"
        @selected="setStatus"
      />
    </div>
  </div>
  <div class="modal__row">
    <div class="modal__body-name">
      Администратор организации
    </div>
    <div class="modal__body-value">
      <SimpleSelect
        light
        :default="orgAdmin.selected"
        :options="orgAdmin.options"
        @selected="setAdminStatus"
      />
    </div>
  </div>
  <div class="modal__actions">
    <div class="col-12 col-md-4 col-xl-3">
      <button
        class="purchases__button purchases__button--white nowrap-text"
        @click="closeModal"
      >
        Вернуться к списку
      </button>
    </div>
    <div class="col-12 col-md-4 col-xl-3">
      <button
        class="purchases__button"
        @click="save"
      >
        Сохранить
      </button>
    </div>
    <!--    <div class="col-12 col-md-4 col-xl-3">-->
    <!--      <button class="purchases__button purchases__button&#45;&#45;white" @click="blocked">Заблокировать</button>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';
import { getRolesString } from '@/utils/helpers';
import SimpleSelect from '@/components/elements/SimpleSelect.vue';
import SelectForm from '@/components/form/select-form.vue';

export default defineComponent({
  name: 'UserModalBodyItem',
  components: { SelectForm, SimpleSelect },
  props: {
    item: { type: [String, Object] },
  },
  emits: ['closeModal'],
  data() {
    return {
      status: '',
      adminStatus: false,
      roleIds: [],
    };
  },
  computed: {
    roles() {
      return getRolesString(this.item?.roles);
    },
    getCurrentRoleIds() {
      const roles = this.item?.roles;
      if (Array.isArray(roles)) {
        return roles.filter((role) => this.allowRoles.some((allowRole) => allowRole.value === role.id)).map((role) => role.id);
      }
      return [];
    },
    statusOptions() {
      return [
        {
          title: 'Авторизован',
          key: 'Авторизован',
        },
        {
          title: 'На рассмотрении',
          key: 'На рассмотрении',
        },
        {
          title: 'Заблокирован',
          key: 'Заблокирован',
        },
      ];
    },
    allowRoles() {
      return [
        {
          value: 5,
          label: 'Поставщик',
        },
        {
          value: 6,
          label: 'Подрядчик',
        },
      ];
    },
    orgAdmin() {
      const selected = this.adminStatus ? 'Да' : 'Нет';
      return {
        selected,
        options: [
          {
            title: 'Да',
            key: true,
          },
          {
            title: 'Нет',
            key: false,
          },
        ],
      };
    },
  },
  watch: {
    status(val) {
      console.log(val);
    },
    adminStatus(val) {
      console.log(val);
    },
  },
  mounted() {
    this.status = this.item.status;
    this.adminStatus = this.item.isAdmin;
    this.roleIds = [];

    if (!this.hasCustomerRole(this.item)) {
      this.roleIds = this.getCurrentRoleIds;
    }
  },
  methods: {
    ...mapActions('admin', ['changeUserStatus']),
    setStatus(status) {
      this.status = status.key;
    },
    hasCustomerRole(user) {
      return user.roles.some((role) => role.name === 'customer');
    },
    setAdminStatus(status) {
      this.adminStatus = status.key;
    },
    closeModal() {
      this.$emit('closeModal');
    },
    async save() {
      const result = await this.changeUserStatus({
        id: this.item.id,
        status: this.status,
        isAdmin: this.adminStatus,
        roleIds: this.roleIds,
      });
      if (result) {
        this.closeModal();
      } else {
        console.error('[save]: Не удалось отправить на сервер.');
      }
    },
    async blocked() {
      this.status = 'Заблокирован';
      this.adminStatus = false;
      const result = await this.changeUserStatus({
        id: this.item.id,
        status: 'Заблокирован',
        isAdmin: false,
      });
      if (result) {
        this.closeModal();
      } else {
        console.error('[save]: Не удалось отправить на сервер.');
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.nowrap-text {
  white-space: nowrap;
}
</style>
